import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit {

  public paddingtop: number = 160;
  public onboradclients: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  manageMachines(){
    this.router.navigateByUrl('managemachines'); 
  }

  Clinics(){
    this.router.navigateByUrl('manageclinics'); 
  }

  Users(){
    this.router.navigateByUrl('manageusers'); 
  }

  Patients(){
    this.router.navigateByUrl('managepatients'); 
  }
  ImportData(){
    this.router.navigateByUrl('importdata');
  }
  // exitBtnClickEvent(){ 
  //   this.router.navigateByUrl('landing'); 
  // }
}
